// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const oddish: PokeData = {
  "id": 43,
  "name": "oddish",
  "height": 5,
  "weight": 54,
  "base_experience": 64,
  "types": [
    PokeType.GRASS,
    PokeType.POISON
  ],
  "api_moves": [
    "acid",
    "absorb",
    "mega-drain",
    "growth",
    "razor-leaf",
    "solar-beam",
    "poison-powder",
    "stun-spore",
    "sleep-powder",
    "petal-dance",
    "toxic",
    "giga-drain",
    "sweet-scent",
    "moonlight",
    "natural-gift",
    "lucky-chant",
    "grassy-terrain",
    "moonblast"
  ],
  "moves": [
    "acid",
    "razor-leaf",
    "solar-beam",
    "poison-powder",
    "stun-spore",
    "moonlight",
    "grassy-terrain",
    "moonblast",
    "aromatherapy",
    "poison-gas",
    "toxic-spikes",
    "purify",
    "mortal-gas"
  ],
  "evolution_chain": {
    "id": 18,
    "item": null,
    "species": [
      {
        "name": "oddish",
        "order": 47,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gloom",
        "order": 48,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": 43,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 21,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "vileplume",
        "order": 49,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": 44,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "leaf-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "bellossom",
        "order": 50,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 44,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "sun-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 52.5,
    "speed": 30,
    "ability_power": 75
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
